import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CalendarPageComponent } from './calendar-page/calendar-page.component';
import { ConfigPageComponent } from './config-page/config-page.component';

const routes: Routes = [
  { path: '', component: CalendarPageComponent },
  { path: 'config', component: ConfigPageComponent }
]

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forRoot(routes)
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
